import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "popcontainer-style2"
};
const _hoisted_2 = {
  class: "imgcontent"
};
const _hoisted_3 = {
  class: "swiper-wrapper"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "swiper-pagination",
  ref: "swiperpage"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "fun1box"
};
const _hoisted_9 = {
  class: "textcontainer"
};
const _hoisted_10 = {
  class: "txtbox"
};
const _hoisted_11 = {
  class: "title"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = {
  key: 1
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "funbox"
};
const _hoisted_16 = {
  style: {
    "display": "none"
  }
};
const _hoisted_17 = {
  key: 0,
  class: "li1"
};
const _hoisted_18 = {
  key: 1,
  class: "li2"
};
const _hoisted_19 = {
  key: 2,
  class: "li3"
};
const _hoisted_20 = {
  key: 3,
  class: "li4"
};
const _hoisted_21 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_circle_close_filled = _resolveComponent("circle-close-filled");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_BellFilled = _resolveComponent("BellFilled");
  const _component_CaretRight = _resolveComponent("CaretRight");
  const _component_PictureFilled = _resolveComponent("PictureFilled");
  const _component_Location = _resolveComponent("Location");
  const _component_Cellphone = _resolveComponent("Cellphone");
  const _component_position = _resolveComponent("position");
  const _component_promotion = _resolveComponent("promotion");
  const _component_list = _resolveComponent("list");
  const _component_home_filled = _resolveComponent("home-filled");
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_icon, {
    class: "icon_close",
    onClick: $options.closePop
  }, {
    default: _withCtx(() => [_createVNode(_component_circle_close_filled)]),
    _: 1
  }, 8, ["onClick"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: _normalizeClass(["swiper-container swiperbox visibleitem", {
      'on': _ctx.$attrs.detail.currentShowtype === 'banner'
    }]),
    ref: "swipercontainer"
  }, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.detail.banner, (item, i) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide",
      key: i
    }, [_createElementVNode("img", {
      src: $options.sethandleHttp(item.fileUrl)
    }, null, 8, _hoisted_4)]);
  }), 128))]), _createElementVNode("div", _hoisted_5, null, 512)], 2), _createElementVNode("video", {
    class: _normalizeClass(["visibleitem", {
      'on': _ctx.$attrs.detail.currentShowtype === 'video'
    }]),
    ref: "videoItem",
    src: _ctx.$attrs.detail.videourl,
    controls: "",
    autoplay: ""
  }, null, 10, _hoisted_6), _createElementVNode("audio", {
    class: _normalizeClass(["visibleitem", {
      'on': _ctx.$attrs.detail.currentShowtype === 'audio'
    }]),
    ref: "audioItem",
    src: _ctx.$attrs.detail.audiourl,
    controls: "",
    autoplay: ""
  }, null, 10, _hoisted_7)]), _createElementVNode("ul", _hoisted_8, [_ctx.$attrs.detail.audio !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    class: "li2",
    onClick: _cache[0] || (_cache[0] = $event => $options.showType('audio'))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_BellFilled)]),
    _: 1
  }), _cache[7] || (_cache[7] = _createElementVNode("span", null, "音频", -1))])) : _createCommentVNode("", true), _ctx.$attrs.detail.video !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 1,
    class: "li3",
    onClick: _cache[1] || (_cache[1] = $event => $options.showType('video'))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CaretRight)]),
    _: 1
  }), _cache[8] || (_cache[8] = _createElementVNode("span", null, "视频", -1))])) : _createCommentVNode("", true), _ctx.$attrs.detail.banner !== '' ? (_openBlock(), _createElementBlock("li", {
    key: 2,
    class: "li1",
    onClick: _cache[2] || (_cache[2] = $event => $options.showType('banner'))
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_PictureFilled)]),
    _: 1
  }), _cache[9] || (_cache[9] = _createElementVNode("span", null, "图片", -1))])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$attrs.detail.placeName), 1), _ctx.$attrs.detail.address14 !== undefined && _ctx.$attrs.detail.address14 !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_12, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Location)]),
    _: 1
  }), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.address14), 1)])) : _createCommentVNode("", true), _ctx.$attrs.detail.telphone !== undefined && _ctx.$attrs.detail.telphone !== '' ? (_openBlock(), _createElementBlock("p", _hoisted_13, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Cellphone)]),
    _: 1
  }), _createTextVNode(" " + _toDisplayString(_ctx.$attrs.detail.telphone), 1)])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: "infodesc",
    innerHTML: _ctx.$attrs.detail.introduce
  }, null, 8, _hoisted_14)]), _createElementVNode("ul", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$attrs.detail), 1), _ctx.$attrs.detail.route !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_17, [_createElementVNode("a", {
    onClick: _cache[3] || (_cache[3] = $event => $options.goLocation(_ctx.$attrs.detail)),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_position)]),
    _: 1
  }), _cache[10] || (_cache[10] = _createElementVNode("span", null, "路线", -1))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.virtualLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_18, [_createElementVNode("a", {
    onClick: _cache[4] || (_cache[4] = $event => $options.goLink(_ctx.$attrs.detail.virtualLink)),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_promotion)]),
    _: 1
  }), _cache[11] || (_cache[11] = _createElementVNode("span", null, "虚拟展馆", -1))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.specialLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_19, [_createElementVNode("a", {
    onClick: _cache[5] || (_cache[5] = $event => $options.goLink(_ctx.$attrs.detail.specialLink)),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_list)]),
    _: 1
  }), _cache[12] || (_cache[12] = _createElementVNode("span", null, "专题", -1))])])) : _createCommentVNode("", true), _ctx.$attrs.detail.portalLink !== '' ? (_openBlock(), _createElementBlock("li", _hoisted_20, [_createElementVNode("a", {
    onClick: _cache[6] || (_cache[6] = $event => $options.goLink(_ctx.$attrs.detail.portalLink)),
    target: "_blank"
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_home_filled)]),
    _: 1
  }), _cache[13] || (_cache[13] = _createElementVNode("span", null, "门户", -1))])])) : _createCommentVNode("", true)])])], 512), [[_vShow, _ctx.$attrs.popshowflag]]), _withDirectives(_createElementVNode("iframe", {
    id: "popiframe",
    src: _ctx.iframeurl,
    frameborder: "0"
  }, null, 8, _hoisted_21), [[_vShow, $data.linkcontainerflag]]), _withDirectives(_createVNode(_component_el_button, {
    class: "goback",
    onClick: $options.goback,
    round: ""
  }, {
    default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("返回")])),
    _: 1,
    __: [14]
  }, 8, ["onClick"]), [[_vShow, $data.linkcontainerflag]])], 64);
}